import * as React from 'react';
import { StyledDivAvatarLayout } from './WhiteLabelMobileAvatar.style';
export const WhiteLabelMobileAvatar = ({ avatarUrl, avatarColor }) => (React.createElement(StyledDivAvatarLayout, { id: 'whiteLabelMobileAvatar_avatar', url: avatarUrl, color: avatarColor }));
//# sourceMappingURL=WhiteLabelMobileAvatar.js.map